import React from 'react';
import { ME } from './data.jsx';
import { Button, LogoMark, Pill, Spinner, Tabs } from './ds/fgcp-ds.jsx';

// components.jsx — local console helpers. DS components come from the bundle.

// Lucide path data, rendered inline as SVG (React-safe; no DOM mutation pass).
const IP = {
  'home': '<path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M9 22V12h6v10"/>',
  'file-check': '<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z"/><path d="M14 2v5h5"/><path d="m9 15 2 2 4-4"/>',
  'file-text': '<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z"/><path d="M14 2v5h5"/><path d="M16 13H8"/><path d="M16 17H8"/><path d="M10 9H8"/>',
  'megaphone': '<path d="m3 11 18-5v12L3 14v-3z"/><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/>',
  'users': '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>',
  'calendar': '<rect width="18" height="18" x="3" y="4" rx="2"/><path d="M3 10h18"/><path d="M8 2v4"/><path d="M16 2v4"/>',
  'umbrella': '<path d="M12 2v2"/><path d="M2 12a10 10 0 0 1 20 0Z"/><path d="M12 12v8a2 2 0 0 0 4 0"/>',
  'check-square': '<path d="m9 11 3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>',
  'grid': '<rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="14" y="3" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/>',
  'search': '<circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>',
  'bell': '<path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/>',
  'settings': '<path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/>',
  'chevron-down': '<path d="m6 9 6 6 6-6"/>', 'chevron-right': '<path d="m9 18 6-6-6-6"/>', 'chevron-left': '<path d="m15 18-6-6 6-6"/>',
  'x': '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>', 'plus': '<path d="M5 12h14"/><path d="M12 5v14"/>',
  'sparkles': '<path d="M9.94 14.34A2 2 0 0 0 8.66 13L3.6 11.3a.6.6 0 0 1 0-1.13L8.66 8.5a2 2 0 0 0 1.28-1.28L11.64 2.2a.6.6 0 0 1 1.13 0l1.7 5.02A2 2 0 0 0 15.34 8.5l5.06 1.7a.6.6 0 0 1 0 1.13l-5.06 1.7a2 2 0 0 0-1.28 1.28l-1.7 5.02a.6.6 0 0 1-1.13 0z"/><path d="M20 3v4"/><path d="M22 5h-4"/>',
  'log-out': '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><path d="M21 12H9"/>',
  'receipt': '<path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"/><path d="M16 8H8"/><path d="M16 12H8"/>',
  'flask-conical': '<path d="M10 2v7.31"/><path d="M14 9.3V2"/><path d="M8.5 2h7"/><path d="M14 9.3a6.5 6.5 0 1 1-4 0"/><path d="M5.58 16.5h12.85"/>',
  'bug': '<path d="m8 2 1.88 1.88"/><path d="M14.12 3.88 16 2"/><path d="M9 7.13v-1a3.003 3.003 0 1 1 6 0v1"/><path d="M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6"/><path d="M12 20v-9"/><path d="M6.53 9C4.6 8.8 3 7.1 3 5"/><path d="M6 13H2"/><path d="M3 21c0-2.1 1.7-3.9 3.8-4"/><path d="M20.97 5c0 2.1-1.6 3.8-3.5 4"/><path d="M22 13h-4"/><path d="M17.2 17c2.1.1 3.8 1.9 3.8 4"/>',
  'terminal': '<path d="m4 17 6-6-6-6"/><path d="M12 19h8"/>',
  'activity': '<path d="M22 12h-4l-3 9L9 3l-3 9H2"/>',
  'shield': '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>',
  'check': '<path d="M20 6 9 17l-5-5"/>',
  'check-circle': '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="m9 11 3 3L22 4"/>',
  'clock': '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>',
  'paperclip': '<path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48"/>',
  'message-square': '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>',
  'arrow-right': '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
  'arrow-up-right': '<path d="M7 7h10v10"/><path d="M7 17 17 7"/>',
  'building': '<rect width="16" height="20" x="4" y="2" rx="2"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01"/><path d="M16 6h.01"/><path d="M12 6h.01"/><path d="M12 10h.01"/><path d="M8 10h.01"/><path d="M16 10h.01"/>',
  'wrench': '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>',
  'mail': '<rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>',
  'filter': '<polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>',
  'printer': '<path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><path d="M6 9V2h12v7"/><rect width="12" height="8" x="6" y="14"/>',
  'download': '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" x2="12" y1="15" y2="3"/>',
  'link': '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>',
  'rotate-ccw': '<path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/>',
  'refresh-cw': '<path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/>',
  'corner-down-right': '<polyline points="15 10 20 15 15 20"/><path d="M4 4v7a4 4 0 0 0 4 4h12"/>',
  'user-plus': '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M19 8v6"/><path d="M22 11h-6"/>',
  // 관리 화면에서 쓰는데 빠져 있던 것(Lucide, ISC)
  'database': '<ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M3 5V19A9 3 0 0 0 21 19V5"/><path d="M3 12A9 3 0 0 0 21 12"/>',
  'key': '<path d="m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4"/><path d="m21 2-9.6 9.6"/><circle cx="7.5" cy="15.5" r="5.5"/>',
  'box': '<path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/>',
  'loader': '<path d="M12 2v4"/><path d="m16.2 7.8 2.9-2.9"/><path d="M18 12h4"/><path d="m16.2 16.2 2.9 2.9"/><path d="M12 18v4"/><path d="m4.9 19.1 2.9-2.9"/><path d="M2 12h4"/><path d="m4.9 4.9 2.9 2.9"/>',
  'user': '<path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>',
  'user-x': '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="17" x2="22" y1="8" y2="13"/><line x1="22" x2="17" y1="8" y2="13"/>',
  'send': '<path d="m22 2-7 20-4-9-9-4Z"/><path d="M22 2 11 13"/>',
  'star': '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>',
  'book': '<path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/>',
  'code': '<polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/>',
  'inbox': '<polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>',
};

function Icon({ name, size = 15, color = 'currentColor', sw = 1.5, style }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={sw}
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
      style={{ display: 'block', flex: 'none', ...(style || {}) }}
      dangerouslySetInnerHTML={{ __html: IP[name] || '' }} />
  );
}

/**
 * 서비스 아이콘 — 이름은 서버(서비스 등록 정보의 icon, 관리자가 적는 글자)에서 온다. 이 화면의 아이콘 목록에 없는 이름이면 빈칸 대신 기본(box)을 그린다
 * (2026-10-05 운영 '연동 예제'의 code가 빈칸으로 보였다)
 */
function AppIcon({ name, ...rest }) {
  return <Icon name={Object.prototype.hasOwnProperty.call(IP, name) ? name : 'box'} {...rest} />;
}

// Initials avatar. Orange fill carries --acc-ink (RULE 2); others use brand blue.
// '나' 강조는 넘겨준 사용자 id로만 판단한다(이름이 같은 사람이 있을 수 있다 — 계획 문서 D16). id를 모르면 강조하지 않는다.
function Avatar({ name, userId, size = 26, tone }) {
  const t = tone || (userId && userId === ME.id ? 'acc' : 'b');
  return <div className={'av' + (t === 'b' ? ' b' : '')} style={{ width: size, height: size, fontSize: Math.round(size * 0.42) }}>{(name || '?')[0]}</div>;
}

// Console panel + its header row.
function Panel({ children, style, scroll }) {
  return <div className="panel" style={{ ...(scroll ? { overflowX: 'auto' } : null), ...(style || {}) }}>{children}</div>;
}
function PH({ title, sub, right }) {
  return (
    <div className="ph">
      <h3>{title}</h3>
      {sub && <span className="sub">{sub}</span>}
      {right && <div className="r">{right}</div>}
    </div>
  );
}
function Lbl({ children, style }) { return <div className="lbl" style={style}>{children}</div>; }

// status → DS Pill tone
const ST = {
  submitted: ['진행', 'info'], approved: ['승인', 'ok'], rejected: ['반려', 'crit'],
  draft: ['임시', 'neutral'], cancelled: ['취소', 'neutral'], withdrawn: ['회수', 'neutral'],
  pending: ['대기', 'warn'], waiting: ['예정', 'neutral'],
  doing: ['진행', 'info'], todo: ['등록', 'neutral'], hold: ['보류', 'warn'], done: ['완료', 'ok'],
};
function StatusPill({ s, dot = true }) {
  const [ko, tone] = ST[s] || [s, 'neutral'];
  return <Pill tone={tone} dot={dot}>{ko}</Pill>;
}

// Overlay shells
/**
 * 창 — 화면보다 내용이 길면 본문만 스크롤한다(머리·버튼 줄은 그대로 보인다). 창 높이는 화면의 84%까지
 * (2026-10-04: 알림 설정 항목이 늘자 아래 칸이 화면 밖으로 잘려 누를 수 없던 것을 고침). 버튼이 많으면 버튼 줄이 접힌다(반복 예약 상세).
 */
function Modal({ width = 460, title, icon, onClose, children, footer }) {
  return (
    <div className="ovl" onClick={onClose}>
      <div className="modal" style={{ width, maxWidth: '92vw', maxHeight: '84vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px 18px', borderBottom: '1px solid var(--line)', flex: 'none' }}>
          {icon && <Icon name={icon} size={16} color="var(--acc)" />}
          <span style={{ fontSize: 14, fontWeight: 700, letterSpacing: '-.02em', whiteSpace: 'nowrap' }}>{title}</span>
          <button onClick={onClose} className="ico" style={{ marginLeft: 'auto' }} aria-label="닫기"><Icon name="x" size={16} /></button>
        </div>
        <div style={{ padding: 18, overflowY: 'auto', minHeight: 0 }}>{children}</div>
        {footer && <div style={{ padding: '12px 18px', borderTop: '1px solid var(--line)', background: 'var(--surface-2)', display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'flex-end', flex: 'none' }}>{footer}</div>}
      </div>
    </div>
  );
}

function Drawer({ width = 440, onClose, children }) {
  const [on, setOn] = React.useState(false);
  React.useEffect(() => { const t = setTimeout(() => setOn(true), 20); return () => clearTimeout(t); }, []);
  return (
    <div className="drawer" onClick={onClose}>
      <div className="dpanel" onClick={e => e.stopPropagation()} style={{
        width, maxWidth: '92vw',
        transform: on ? 'translateX(0)' : 'translateX(22px)', opacity: on ? 1 : 0,
        transition: 'transform var(--dur-slow) var(--ease), opacity var(--dur-slow) var(--ease)',
      }}>{children}</div>
    </div>
  );
}

function DrawerHead({ title, sub, onClose, right }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '15px 18px', borderBottom: '1px solid var(--line)', flex: 'none' }}>
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ fontSize: 14.5, fontWeight: 700, letterSpacing: '-.02em', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{title}</div>
        {sub && <div className="mono" style={{ fontSize: 11, color: 'var(--ink-3)', marginTop: 2, whiteSpace: 'nowrap' }}>{sub}</div>}
      </div>
      {right}
      <button onClick={onClose} className="ico" aria-label="닫기"><Icon name="x" size={16} /></button>
    </div>
  );
}

// key/value pair, mono value
function KV({ k, v, mono = true }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, fontSize: 12.5, whiteSpace: 'nowrap' }}>
      <span style={{ color: 'var(--ink-3)' }}>{k}</span>
      <span className={mono ? 'mono' : ''} style={{ fontWeight: 600, color: 'var(--ink)' }}>{v}</span>
    </div>
  );
}

/** 불러오는 중 — DS Spinner(빈 상태 크기)와 글 */
function Loading({ title = '불러오는 중' }) {
  return (
    <div data-loading style={{ padding: '48px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, textAlign: 'center' }}>
      <Spinner size={24} label={title} />
      <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink-2)' }}>{title}</div>
    </div>
  );
}

/** 고른 것 하나(사람·대상 등) — DS Pill(점 없음)에 빼기 버튼(DS Button ghost)을 붙인 조합. onRemove가 없으면 표시만 */
function Token({ children, onRemove, removeLabel, tone = 'neutral', ...rest }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 2 }} {...rest}>
      <Pill tone={tone} dot={false}>{children}</Pill>
      {onRemove && <Button size="sm" variant="ghost" aria-label={removeLabel} onClick={onRemove} style={{ padding: '2px 5px', lineHeight: 0 }}><Icon name="x" size={11} /></Button>}
    </span>
  );
}

/** 화면 위 탭 줄 — DS Tabs를 화면 머리와 같은 들여쓰기로 둔다 */
function PageTabs({ items, value, onChange }) {
  return <div data-page-tabs style={{ padding: '0 22px' }}><Tabs items={items} value={value} onChange={onChange} /></div>;
}

function Empty({ icon = 'inbox', title, sub }) {
  return (
    <div style={{ padding: '48px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 11, textAlign: 'center' }}>
      <div style={{ width: 44, height: 44, borderRadius: 'var(--r-ctl)', border: '1px solid var(--line)', background: 'var(--surface-2)', display: 'grid', placeItems: 'center' }}>
        <Icon name={icon} size={20} color="var(--ink-3)" />
      </div>
      <div>
        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink-2)' }}>{title}</div>
        {sub && <div style={{ fontSize: 11.5, color: 'var(--ink-3)', marginTop: 3 }}>{sub}</div>}
      </div>
    </div>
  );
}

export { AppIcon, Avatar, Drawer, DrawerHead, Empty, IP, Icon, KV, Lbl, Loading, Modal, PageTabs, PH, Panel, ST, StatusPill, Token };
